import {SuccessMessages} from 'constants/Success';

import {faEnvelope} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import Button from 'components/Button/Button';
import {ErrorMessage, Field, Form, Formik} from 'formik';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import {inviteNewPageEditor} from 'services/admin-data';
import {setErrorAC, setSuccessAC} from 'store/app/appSlice';
import {setModalAC} from 'store/modal/modalSlice';
import {isAxiosError} from 'typescript/guards/AxiosGuards';
import * as yup from 'yup';

import './InvitePageEditor.scss';

interface FormValues {
  email: string;
}

const invitePageEditorValidationSchema = yup.object({
  email: yup.string().email('Email is not valid').required('Email is required'),
});

const InvitePageEditor = () => {
  const dispatch = useSetGlobalState();
  const handleClose = () => dispatch(setModalAC(null));

  const handleInvitePageEditor = async ({email}: FormValues) => {
    try {
      await inviteNewPageEditor(email.trim());
      dispatch(setSuccessAC(SuccessMessages.INVITE_PAGE_EDITOR));
      handleClose();
    } catch (error) {
      if (isAxiosError(error)) {
        if (error.response?.data?.errors?.email) {
          dispatch(setErrorAC('Page editor with this email already exist'));
        } else {
          dispatch(setErrorAC('Invite failed'));
        }
      } else {
        dispatch(setErrorAC('Unknown error'));
      }
    }
  };

  return (
    <Formik
      initialValues={{email: ''}}
      onSubmit={handleInvitePageEditor}
      validationSchema={invitePageEditorValidationSchema}
    >
      <Form className="invite-page-editor">
        <h1 className="invite-page-editor__title">Invite Page Editor</h1>
        <p className="invite-page-editor__description">
          Enter the email of the user/editor you want to add. We&apos;ll email the instructions to the user for logging
          in. You&apos;ll be notified when the user accepts the invitation.
        </p>
        <div className="invite-page-editor__email-wrapper">
          <label className="invite-page-editor__email-input">
            <FontAwesomeIcon icon={faEnvelope} />
            <Field name="email" placeholder="email@example.com" />
          </label>

          <ErrorMessage component="span" className="invite-page-editor__email-error" name="email" />
        </div>
        <div className="invite-page-editor__actions">
          <Button variant="tertiary-outlined" className="invite-page-editor__cancel" onClick={handleClose}>
            Cancel
          </Button>
          <Button type="submit" variant="tertiary" className="invite-page-editor__send-invitation">
            Send an Invitation
          </Button>
        </div>
      </Form>
    </Formik>
  );
};

export default InvitePageEditor;
